module.exports = __webpack_public_path__ + "static/media/subaruoutback-1998bg.32cab4b5.jpg";